import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=0a8eacd0"
import script from "./SplitView.vue?vue&type=script&lang=js"
export * from "./SplitView.vue?vue&type=script&lang=js"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=0a8eacd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports